var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 93.45 74.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_268);}.cls-2{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_270);}.cls-3{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_258);}.cls-4{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_532);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_268",
    x1: 11.51,
    y1: 58.68,
    x2: 37.73,
    y2: 41.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#019867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#09ac8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#11bda9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#17cbc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1bd6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1fdee3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#20e3eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21e4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_270",
    x1: 13.59,
    y1: 17.84,
    x2: 3.28,
    y2: 73.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d81ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0c88ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#069fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#03b0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#01baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#0ed0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#21eab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2df9a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31ff98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_258",
    x1: 0.01,
    y1: 20.38,
    x2: 81.46,
    y2: 20.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#008cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0089fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#007ff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#006ee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_532",
    x1: 74,
    y1: 67.59,
    x2: 71.16,
    y2: 17.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00a7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007dde"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_3",
    "data-name": "\\u56FE\\u5C42 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.74 49.4 23.96 37.98 23.96 46.99 11.98 53.91 11.98 67.74 43.74 49.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,74.66,19.65,63.31s-4.19.23-6.44-2.93c-1.45-2-1.23-6.47-1.23-6.47V20.73L0,13.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46.73 26.97 0.01 0 0.01 13.19 11.98 20.73 11.98 20.73 46.68 40.77 81.46 20.68 81.46 6.92 46.73 26.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "81.46 6.92 81.46 20.68 81.46 20.68 81.46 53.9 71.24 48 71.24 36.91 49.66 49.37 74.95 63.97 93.44 74.65 93.45 0 81.46 6.92"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.b4b97d985a85a6d6940b8efa779c36c2.svg";
export { ForwardRef as ReactComponent };